import { InjectionToken } from '@angular/core';

export interface DownloadConfig {
  pageSizeOptions: number[];
  fileDownloadUrl: string;
}

export const DOWNLOAD_CONFIG = new InjectionToken<DownloadConfig>('DownloadConfig');
